import ShowcaseAutomation from '../views/ShowcaseAutomation.vue'
import Showcase from '../views/Showcase.vue'
import ShowcaseOperations from '../views/operation/ShowcaseOperations.vue'

export const SHOWCASE_AUTOMATION = 'Showcase Automation'
export const SHOWCASE_AUTOMATION_PATH = '/'

const ROUTES = [
  {
    path: SHOWCASE_AUTOMATION_PATH,
    name: SHOWCASE_AUTOMATION,
    props: {
      icon: 'mdi-animation'
    },
    component: ShowcaseAutomation
  },
  {
    path: `${SHOWCASE_AUTOMATION_PATH}/:id`,
    name: 'ShowcaseDetails',
    component: Showcase,
    children: [
      {
        path: 'operations',
        name: 'ShowcaseOperations',
        component: ShowcaseOperations
      }
    ]
  }
]

const factory = async () => {
  return ROUTES
}

export default factory
